module.exports = __webpack_public_path__ + "img/yj_recall_bg_top1.9ab4a448.png";